import React from "react";

export default function Academic() {
  const calendar = [
    {
      month: "APRIL 2025",
      events: [
        { date: "01.04.2025", detail: "Commencement of Session for Classes IX – X & XII" },
        { date: "17.04.2025", detail: "Recitation in English" },
        { date: "19.04.2025", detail: "Recitation in Hindi" },
      ],
    },

    {
      month: "MAY 2025",
      events: [
        { date: "06.05.2025", detail: "Essay Writing in English" },
        { date: "07.05.2025", detail: "Essay Writing in Hindi" },
        { date: "09.05.2025", detail: "Rabindra Jayanti" },
        { date: "12.05.2025", detail: "Commencement of Summer Vacation" },
      ],
    },

    {
      month: "JUNE 2025",
      events: [
        { date: "23.06.2025", detail: "School reopens after Summer Vacation" },
      ],
    },

    {
      month: "JULY 2025",
      events: [
        { date: "24.07.2025", detail: "First Periodic Test for Class IX, X & XII" },
      ],
    },

    {
      month: "AUGUST 2025",
      events: [
        { date: "1st Week", detail: "Tulsi Jayanti" },
        { date: "05.08.2025", detail: "Inter House Kabaddi Tournament" },
        { date: "15.08.2025", detail: "Celebration of Independence Day" },
      ],
    },

    {
      month: "SEPTEMBER 2025",
      events: [
        { date: "05.09.2025", detail: "Teachers Day Celebration" },
        { date: "06.09.2025", detail: "Inter House Patriotic Song Competition" },
        { date: "19.09.2025", detail: "Second Periodic Test for Class IX, X & XII" },
        { date: "", detail: "First Periodic Test for Class XI" },
        { date: "29.09.2025", detail: "Commencement of Puja Vacation (Break-I)" },
      ],
    },

    {
      month: "OCTOBER 2025",
      events: [
        { date: "09.10.2025", detail: "School Reopens after Break-I" },
        { date: "16.10.2025", detail: "Annual Day & Prize Giving Ceremony" },
        { date: "18.10.2025", detail: "Commencement of Diwali & Chhath (Break-II)" },
        { date: "29.10.2025", detail: "School Reopens after Break-II" },
      ],
    },

    {
      month: "NOVEMBER 2025",
      events: [
        { date: "14.11.2025", detail: "Children’s Day Celebration" },
        { date: "25.11.2025", detail: "Third Periodic Test for Class IX" },
        { date: "", detail: "Second Periodic Test for Class XI" },
        { date: "", detail: "First Preboard for Class X" },
        { date: "", detail: "Final Preboard for Class XII" },
      ],
    },

    {
      month: "NOVEMBER & DECEMBER 2025",
      events: [
        { date: "Proposed", detail: "Olympiad Test (English / Math / Science)" },
        { date: "Proposed", detail: "Annual Sports" },
        { date: "24.12.2025", detail: "Commencement of Winter Break (Phase-II)" },
      ],
    },

    {
      month: "JANUARY 2026",
      events: [
        { date: "08.01.2026", detail: "Final Preboard of Class X" },
        { date: "12.01.2026", detail: "Celebration of Youth Day" },
        { date: "23.01.2026", detail: "Celebration of Netaji’s Birthday" },
        { date: "26.01.2026", detail: "Celebration of Republic Day" },
      ],
    },

    {
      month: "FEBRUARY 2026",
      events: [
        { date: "3rd Week of February", detail: "Annual / Session Ending Exam for Class IX & XI" },
      ],
    },

    {
      month: "MARCH 2026",
      events: [
        { date: "Proposed", detail: "Declaration of Result & End of Academic Session 2025-26" },
      ],
    },
  ];

  return (
    <div className="container">
      <h2 id="h2">
        S.E. RAILWAY MIXED H S SCHOOL, ADRA (CAMPUS - I)
        <br />
        ACADEMIC CALENDAR
        <br />
        SESSION 2025-2026
      </h2>

      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Month</th>
            <th>Date</th>
            <th>Events</th>
          </tr>
        </thead>

        <tbody>
          {calendar.map(({ month, events }) =>
            events.map((evt, idx) => (
              <tr key={`${month}-${idx}`}>
                {idx === 0 && (
                  <th rowSpan={events.length}>
                    {month}
                  </th>
                )}
                <td>{evt.date}</td>
                <td>{evt.detail}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="text-center my-4">
        <a
          href="/Acedemic Calender 2025-26.pdf"
          className="btn btn-primary"
          download
        >
          Download Academic Calendar
        </a>
      </div>
    </div>
  );
}
